import Button from '@zenbusiness/zui/Button';
import { styled } from '@zenbusiness/zui/styles';

export const PrintButton = styled(Button)(() => ({
  padding: '0 !important',
  height: 'auto',
  '&:hover': {
    backgroundColor: 'transparent'
  }
}));
